import { createApp } from 'vue';
import { FhToastPlugin } from '@fareharbor-com/beacon-vue/plugins';
import { createPinia } from 'pinia';
import { initializeSentry } from '@/common/sentry/initializeSentry';
import { useFeatureFlagStore } from '@/composables/useFeatureFlagStore';
import tracking from '@/plugins/tracking';
import router from '@/router';
import { setRouteErrorHandler } from '@/router/setRouteErrorHandler';
import App from './App.vue';
import './assets/style/main.css';
import './index.css';

setRouteErrorHandler(router);

const app = createApp(App);

app.use(createPinia());
app.use(FhToastPlugin);
app.use(tracking);
app.use(router);

const featureFlagStore = useFeatureFlagStore();
featureFlagStore.loadFlags();

// Initialize Sentry
initializeSentry(app);

app.mount('#app');
